import { Component, ElementRef, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';

@Component({
  selector: `modal-access-full-wallet`,
  templateUrl: './modal-access-full-wallet.component.html',
  styleUrls: ['./modal-access-full-wallet.component.scss']
})
export class ModalAccessFullWalletComponent extends DialogComponentContent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAccessFullWalletComponent>,
    public element: ElementRef,
  ) {
    super(element);
  }

  public closeModal() {
      this.dialogRef.close(true);
  }
}
